<template>
  <div class="showcase">
    <div class="goods-list">
      <div class="goods-item del_tips--cont" v-for="(item, index) in listData" :key="index">
        <div class="del_tips" @click.stop="cancelCollect(item)">
          <i class="el-icon-delete"></i>
        </div>
        <div @click="toDetail(item)" style="flex: 1; display: flex;">
          <div class="goods-item-date">
            <div class="date">{{ item.month }}-{{ item.day }}</div>
            <div class="year">{{ item.year }}</div>
            <div class="icon"></div>
          </div>
          <div class="goods-item-info">
            <div class="title multiple-ellipsis">{{ item.title }}</div>
            <div class="content multiple-ellipsis">
              <span class="txt" v-html="item.content"></span>
            </div>
          </div>
        </div>
        <div class="goods-item-img" style="position: relative;">
          <div class="goods-img" v-if="item.cover">
            <el-image class="image" :src="item.cover" @error="handleError" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCollect } from "@/api/common"
import dayjs from "dayjs"
export default {
  name: "CoreSkills",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => new Array(),
    },
  },
  data() {
    return {
      moreicon: require("@/assets/home/open.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
      listData: [],
    }
  },
  computed: {},
  watch: {
    list: {
      handler(newV) {
        if (!newV.length) {
          this.listData = []
          return false
        }
        this.listData = newV.map(item => {
          let dateStr = dayjs.unix(item.updated_at).format("YYYY-MM-DD").split('-')
          item.year = dateStr[0]
          item.month = dateStr[1]
          item.day = dateStr[2]
          return item
        })

      },
      immediate: true,
      deep: true
    }
  },
  mounted() { },
  methods: {
    handleError(e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    toDetail(item) {
      window.localStorage.setItem("menuId", 2)
      this.$store.dispatch("setmenuid", 2)
      this.$router.push({
        path: "/home/news/detail",
        query: {
          id: item.id || "",
        },
      })
    },
    // 取消收藏
    cancelCollect(data) {
      let params = {
        id: data.id,
        type: 1
      }
      setCollect(params).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '取消采集成功!'
          })
          this.$emit('updateComponent')
        }
      }).catch(() => { })
    },
  },
};
</script>
<style scoped lang="scss">
.showcase {
  .goods-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .goods-item {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      width: 100%;
      background-color: #fff;
      overflow: hidden;
      margin-top: 30px;
      padding-bottom: 30px;
      box-sizing: border-box;
      flex-shrink: 1;
      cursor: pointer;
      border-bottom: 1px solid #f7f7f7;
      border-radius: 5px;

      // &:hover {
      //   border: 1px solid rgb(9, 235, 178);
      // }
      .goods-item-img {
        position: relative;

        .goods-img {
          width: 265px;
          min-width: 265px;
          height: 170px;
          overflow: hidden;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            border-radius: 5px;
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }

        .default-img {
          width: 265px;
          min-width: 265px;
          height: 195px;
          // background: #daebfc;
          text-align: center;
          background: aliceblue;

          .image {
            display: inline-block;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          }

          .image:hover,
          .image:focus,
          .image:active {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
          }

          .image {
            width: 100%;
            height: 100%;
          }
        }
      }

      .goods-item-date {
        width: 70px;
        min-width: 70px;
        padding: 20px 30px;

        .date {
          color: #000000;
          font-size: 24px;
          font-weight: 500;
          line-height: 40px;
        }

        .year {
          color: #999999;
          font-size: 12px;
          font-weight: 400;
          line-height: 30px;
        }

        .icon {
          width: 30px;
          height: 30px;
          background: url('~@/assets/home/details_gray.png') no-repeat;
          background-position: center;
          background-size: cover;
          margin-top: 20px;
        }

        &:hover .icon {
          transform: translateX(50%);
          transition: 0.4s all;
        }
      }

      .goods-item-info {
        flex: 1;
        padding: 20px;
        padding-left: 0;
        background: #ffffff;
        box-sizing: border-box;

        .title {
          color: #000000;
          font-size: 18px;
          font-weight: 500;
          line-height: 1.5;
          padding-top: 5px;
          margin-bottom: 10px;
          -webkit-line-clamp: 2 !important;
        }

        .content {
          word-break: break-all;
          white-space: pre-wrap;
          overflow-wrap: break-word;

          .txt {
            color: #333;
            font-size: 12px;
            font-weight: 400;
            text-align: justify;
            line-height: 20px;
            border-radius: 12px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .showcase {
    .goods-list {
      .goods-item {
        flex-direction: column;
        height: auto;
        margin-top: 15px;
        padding-bottom: 15px;

        .del_tips {
          position: absolute;
          top: 8px;
          right: 8px;
          z-index: 2;
          width: 24px;
          height: 24px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-delete {
            color: #fff;
            font-size: 12px;
          }
        }

        .goods-item-img {
          width: 100%;

          .goods-img {
            width: 100%;
            min-width: auto;
            height: 180px;

            .image {
              display: block;
              object-fit: cover;
            }
          }
        }

        .goods-item-date {
          width: auto;
          min-width: auto;
          padding: 10px 15px 5px;
          display: flex;
          align-items: baseline;
          gap: 8px;

          .date {
            font-size: 16px;
            line-height: 1;
          }

          .year {
            font-size: 12px;
            line-height: 1;
          }

          .icon {
            display: none;
          }
        }

        .goods-item-info {
          padding: 0 15px 10px;

          .title {
            font-size: 15px;
            -webkit-line-clamp: 2 !important;
          }

          .content {
            .txt {
              font-size: 11px;
              line-height: 18px;
            }
          }
        }
      }
    }
  }
}
</style>